import { render, staticRenderFns } from "./SelectableProductAttributes.vue?vue&type=template&id=fe64b5f0&"
import script from "./SelectableProductAttributes.vue?vue&type=script&lang=ts&"
export * from "./SelectableProductAttributes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports